 <div class="m-portlet__body">
   <div class="m-section">

     <div class="m-section__content">
       <div class="table-responsive">
         <div class="table table-hover">
           <div class="announcements-subheader-container">
             <span class="text-color-deep-heading header-txt">{{'ANNOUNCEMENTS' | dictionary}}</span>

             <i class="fas fa-bullhorn icon"></i>
           </div>
           <div *ngFor="let item of announcements" (click)="Download(item.DocSeqNum,item.FileNum)"
                class="item-row cursor-pointer">
             <i class="far fa-envelope icon"></i>
             <span
               class="announcements text-color-black">{{item.Label}}</span>
           </div>

           <div *ngIf="!announcements.length">
               <span class="home-announcements ml-3 text-color-deep-heading">{{'NO_NEW_ANNOUNCEMENTS' | dictionary}}</span>
           </div>
         </div>
         <!-- <div class="col-lg-12 more-wrapper" *ngIf="announcements?.length" >
                                 <span class="float-right">
                                   <a href="javascript:void(0);" (click)="navigateToConfirmMsg()">...{{'MORE' | dictionary}}</a></span>
         </div>  -->
       </div>
     </div>
   </div>
 </div>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">
 </app-pop-up-dialog>
